<div class="tool-content-container">
  <div class="tool-description">
    Select a
    <instruction-step-link link="target-semester" text="Target Semester" /> a
    Department, a <instruction-step-link link="program" text="Program" />, a
    <instruction-step-link link="cohort" text="Cohort" />, the range for High
    School GPA [Default: 0-5]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i
    >, a Demographic [Default: None]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i
    >, and click submit to generate results for apr/graduation/summary.
    <!-- a <instruction-step-link link="cohort" text="Cohort" />,  
    <b class="instructions-title"
      >To generate results for apr/graduation/summary:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="target-semester" text="Target Semester" />
    <br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Select a Department<br />
    Step 3 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="program" text="Program" />
    <br />
    Step 4 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="cohort" text="Cohort" />
    <br />
    Step 5 <i class="fa-solid fa-arrow-right"></i> Select the range for High
    School GPA [Default: 0-5]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i>
    <br />
    Step 6 <i class="fa-solid fa-arrow-right"></i> Select a Demographic
    [Default: None]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i
    ><br />
    Step 7 <i class="fa-solid fa-arrow-right"></i> Click on the submit button<br /><br /> -->
    <br /><br />
    <b class="important-note"
      >* The selected cohort year gives detailed information on retention and
      graduation below where the last four graphs are located. Click this link
      <a class="graphs-link" #graphsLink> graphs </a>
      to scroll to the graphs. <br /><br />
      *The default results is generated automatically at the start.</b
    ><br />
  </div>

  <a
    mat-fab
    extended
    color="primary"
    (click)="exportData()"
    *ngIf="this.authService.getRole() !== 'demo' && dataLoaded"
    style="margin-bottom: 10px"
  >
    <mat-icon>download</mat-icon>
    Download
  </a>

  <div class="content-container" *ngIf="dataLoaded">
    <!-------------------------------- APR Trend Table -------------------------------->
    <div class="table-responsive mat-elevation-z8">
      <div class="table-filters-title" [style.paddingTop]="'5px'">
        <p>
          <span [style.fontWeight]="'bold'">Selected:</span>
          College: {{ data.selected_college }} | Department:
          {{ data.selected_department }} | Program: {{ data.selected_program }}
        </p>
      </div>
      <table mat-table [dataSource]="tableData">
        <!-- Cohort Column -->
        <ng-container matColumnDef="cohort">
          <th mat-header-cell *matHeaderCellDef>Cohort</th>
          <td mat-cell *matCellDef="let element">{{ element.cohort }}</td>
        </ng-container>

        <!-- Cohort Size Column -->
        <ng-container matColumnDef="cohort_size">
          <th mat-header-cell *matHeaderCellDef>Cohort_Size</th>
          <td mat-cell *matCellDef="let element">{{ element.cohort_size }}</td>
        </ng-container>

        <!-- Retention Column -->
        <ng-container matColumnDef="retention">
          <th mat-header-cell *matHeaderCellDef>Retention</th>
          <td mat-cell *matCellDef="let element">{{ element.retention }}</td>
        </ng-container>

        <!-- Retention Pct Column -->
        <ng-container matColumnDef="retention_pct">
          <th mat-header-cell *matHeaderCellDef>Retention_Pct</th>
          <td mat-cell *matCellDef="let element">
            {{ element.retention_pct }}
          </td>
        </ng-container>

        <!-- APR Total Column -->
        <ng-container matColumnDef="apr_total">
          <th mat-header-cell *matHeaderCellDef>APR_Total</th>
          <td mat-cell *matCellDef="let element">
            {{ element.apr_total }}
          </td>
        </ng-container>

        <!-- APR Total Pct Column -->
        <ng-container matColumnDef="apr_total_pct">
          <th mat-header-cell *matHeaderCellDef>APR_Total_Pct</th>
          <td mat-cell *matCellDef="let element">
            {{ element.apr_total_pct }}
          </td>
        </ng-container>

        <!-- APR Stay Column -->
        <ng-container matColumnDef="apr_stay">
          <th mat-header-cell *matHeaderCellDef>APR_Stay</th>
          <td mat-cell *matCellDef="let element">{{ element.apr_stay }}</td>
        </ng-container>

        <!-- APR Stay Pct Column -->
        <ng-container matColumnDef="apr_stay_pct">
          <th mat-header-cell *matHeaderCellDef>APR_Stay_Pct</th>
          <td mat-cell *matCellDef="let element">{{ element.apr_stay_pct }}</td>
        </ng-container>

        <!-- APR Migrate Column -->
        <ng-container matColumnDef="apr_migrate">
          <th mat-header-cell *matHeaderCellDef>APR_Migrate</th>
          <td mat-cell *matCellDef="let element">{{ element.apr_migrate }}</td>
        </ng-container>

        <!-- APR Migrate Pct Column -->
        <ng-container matColumnDef="apr_migrate_pct">
          <th mat-header-cell *matHeaderCellDef>APR_Migrate_Pct</th>
          <td mat-cell *matCellDef="let element">
            {{ element.apr_migrate_pct }}
          </td>
        </ng-container>

        <!-- On Time Column -->
        <ng-container matColumnDef="on_time">
          <th mat-header-cell *matHeaderCellDef>On_Time</th>
          <td mat-cell *matCellDef="let element">{{ element.on_time }}</td>
        </ng-container>

        <!-- On Time Pct Column -->
        <ng-container matColumnDef="on_time_pct">
          <th mat-header-cell *matHeaderCellDef>On_Time_Pct</th>
          <td mat-cell *matCellDef="let element">
            {{ element.on_time_pct }}
          </td>
        </ng-container>

        <!-- Over Time Column -->
        <ng-container matColumnDef="over_time">
          <th mat-header-cell *matHeaderCellDef>Over_Time</th>
          <td mat-cell *matCellDef="let element">
            {{ element.over_time }}
          </td>
        </ng-container>

        <!-- Over Time Pct Column -->
        <ng-container matColumnDef="over_time_pct">
          <th mat-header-cell *matHeaderCellDef>Over_Time_Pct</th>
          <td mat-cell *matCellDef="let element">
            {{ element.over_time_pct }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div class="graph-div mat-elevation-z8" style="margin-top: 30px">
      <div class="chart-title-with-btn-icon">
        <p>Trend of APR & Retention & Degree (cohort: 2015-2023)</p>
        <button
          matTooltip="Save chart as image"
          mat-icon-button
          aria-label="Chart snap icon"
          (click)="aprTrendGraphComponent.exportChart()"
        >
          <mat-icon>photo_camera</mat-icon>
        </button>
      </div>
      <p class="chart-sub-heading">
        Selected: ({{ data.selected_college }})-({{
          data.selected_department
        }})-({{ data.selected_program }})
      </p>
      <apr-trend-graph [chartData]="data.cohort_stats"></apr-trend-graph>
    </div>

    <!-- div that holds all four graphs and graph's header -->
    <div #graphs class="graphs-div">
      <div class="apr-chart-head-div">
        <h3 class="graphs-header">
          Filter by cohort, high school GPA, and demographics for selected
          college / department / program
        </h3>
        <p>
          Selected: ({{ data.selected_cohort }})-({{
            data.selected_college
          }})-({{ data.selected_department }})-({{ data.selected_program }})
        </p>
      </div>

      <!-- div that holds two graphs -->
      <div class="two-graph-div">
        <div
          class="enrollment-and-retention-by-falls-graph-div mat-elevation-z8"
        >
          <div class="chart-title-with-btn-icon">
            <p>Enrollment and Retention by Falls (based on current location)</p>
            <button
              matTooltip="Save chart as image"
              mat-icon-button
              aria-label="Chart snap icon"
              (click)="enrollmentRetentionChart.exportChart()"
            >
              <mat-icon>photo_camera</mat-icon>
            </button>
          </div>
          <p class="chart-sub-heading">Enrollment From 1st to 4th Fall</p>
          <enrollment-and-retention-by-falls-graph
            [chartData]="data.enrollment_retention"
            [numStudents]="data.number_of_students"
          ></enrollment-and-retention-by-falls-graph>
        </div>

        <div class="first-fall-gpa-graph-div mat-elevation-z8">
          <div class="chart-title-with-btn-icon">
            <p>First Fall GPA</p>
            <button
              matTooltip="Save chart as image"
              mat-icon-button
              aria-label="Chart snap icon"
              (click)="firstFallGpaChart.exportChart()"
            >
              <mat-icon>photo_camera</mat-icon>
            </button>
          </div>
          <p class="chart-sub-heading">Above a 2.77 GPA or Below</p>
          <first-fall-gpa-graph
            [chartData]="data.first_fall_gpa"
            [numStudents]="data.number_of_students"
          ></first-fall-gpa-graph>
        </div>
      </div>

      <!-- div that holds two graphs -->
      <div class="two-graph-div">
        <div class="students-academic-progress-rate-graph-div mat-elevation-z8">
          <div class="chart-title-with-btn-icon">
            <p>Students Academic Progress Rate (based on entry)</p>
            <button
              matTooltip="Save chart as image"
              mat-icon-button
              aria-label="Chart snap icon"
              (click)="studentAprChart.exportChart()"
            >
              <mat-icon>photo_camera</mat-icon>
            </button>
          </div>
          <p class="chart-sub-heading">&nbsp;</p>
          <students-academic-progress-rate-graph
            [chartData]="data.apr"
            [numStudents]="data.number_of_students"
          ></students-academic-progress-rate-graph>
        </div>

        <div class="graduation-time-graph-div mat-elevation-z8">
          <div class="chart-title-with-btn-icon">
            <p>Graduation Time (based on entry)</p>
            <button
              matTooltip="Save chart as image"
              mat-icon-button
              aria-label="Chart snap icon"
              (click)="fourYearGradRateChart.exportChart()"
            >
              <mat-icon>photo_camera</mat-icon>
            </button>
          </div>
          <p class="chart-sub-heading">Four-Year Graduation Rate</p>
          <four-year-grad-rate-graph
            [chartData]="data.four_year_grad_rate"
            [numStudents]="data.number_of_students"
          ></four-year-grad-rate-graph>
        </div>
      </div>
    </div>
  </div>

  <back-button></back-button>
</div>
